import { Component, Input, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { SecurityController } from '@shared/src/public-api';

@Component({
  selector: 'shared-external-logo',
  templateUrl: './shared.external.logo.component.html',
  styleUrls: ['./shared.external.logo.component.scss'],
})
export class SharedExternalLogoComponent implements OnInit {

  constructor(protected homeController: HomeController) { }

  @Output() clickBack = new EventEmitter<boolean>();

  @Input() public showButtonBack: boolean = true;
  @Input() public goBackToHome: boolean = false;

  public __tenantId: number;
  @Input()
  public set tenantId(value: number) {
      if (this.__tenantId == value)
          return;
      this.__tenantId = value;
      this.loadLogo();
  }
  public get tenantId(): number {
      return this.__tenantId;
  }

  public logoPropi: boolean = false;
  
  public logoImage: FileUpDownLoadDto = null;

  public generalClass = "";
  ngOnInit() {
    this.generalClass = SecurityController.GENERAL_CLASS;
  }
  loadLogo(){
    if (this.logoImage == null && !HLong.isNullOrNullLong(this.tenantId))
      this.homeController.getLogo(this.tenantId).subscribe((data: FileUpDownLoadDto) => {
        this.logoImage = data;
        if (this.logoImage != null && this.logoImage.fileBytes != null && this.logoImage.fileBytes.length > 0)
          this.logoPropi = true;
        else
          this.logoPropi = false;
      });
  }
}
